import React from 'react'

const GlobalContext = React.createContext(
    {safes:[], costCenters: [], groups: [], omlat:[]})

    export default GlobalContext